import { render } from "./LogisticsView.vue?vue&type=template&id=5bde38de&scoped=true"
import script from "./LogisticsView.vue?vue&type=script&lang=js"
export * from "./LogisticsView.vue?vue&type=script&lang=js"

import "./LogisticsView.vue?vue&type=style&index=0&id=5bde38de&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bde38de"]])

export default __exports__